import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { Globals } from 'app/services/globals';
import { finalize } from 'rxjs/operators';
import { WorkflowExec } from 'app/models/workflow-exec';
import { FormGroup } from '@angular/forms';
import { StepCompletionExecution } from 'app/models/step-completion-execution';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-external-complete-workflow-task',
  templateUrl: './external-complete-workflow-task.component.html',
  styleUrls: ['./external-complete-workflow-task.component.scss']
})
export class ExternalCompleteWorkflowTaskComponent implements OnInit {

  workflowExec: WorkflowExec = null;

  isLoading: boolean = false;
  isTaskCompleted: boolean = false;

  errorMsg: string = null;
  
  contactId: number = null;
  token: string = null;

  constructor(private activatedRoute: ActivatedRoute, private workflowExecutionService: WorkflowExecutionService,
              private workflowTemplateService: WorkflowTemplateService, private toastService: ToastService, private globals: Globals, private ecoDocsTitleService: EcoDocsTitleService) {
                this.activatedRoute.params.subscribe(params => {
                  const stepId: number = +params['stepId'];
                  const execId: number = +params['execId'];
                  this.contactId = +params['contactId'];
                  this.token = params['token'];
                  const fqdn: string = this.activatedRoute.snapshot.queryParams.fqdn;

                  // Set the FQDN to talk to the right backend
                  this.globals.api_base_url = this.globals.api_url_scheme + fqdn + this.globals.api_suffix_path;

                  this.isLoading = true;
                  this.workflowExecutionService.getCurrentTaskExternal(execId, stepId, this.contactId, this.token).pipe(finalize(() => {
                    this.isLoading = false;
                  })).subscribe((w) => {
                    this.workflowExec = w;
                    this.ecoDocsTitleService.setTitle(w.current_step.name, false);
                  }, (err) => {
                    if (err.status == 422 && err.message) {
                      if (err.errors.token) {
                        this.errorMsg = "This task is either invalid or has already been completed."
                      } else {
                        this.errorMsg = err.message;
                      }
                    } else if (err.status == 403) {
                      this.errorMsg = "This task either doesn't exist or you don't have access to it."
                    }
                  });
                });
              }

  ngOnInit(): void {
  }

  onCompleted(stepCompletionExecution: StepCompletionExecution) {
    this.isLoading = true;
    this.workflowExecutionService.completeStepExternal(this.workflowExec.id, stepCompletionExecution, this.contactId, this.token).pipe(finalize(() => {
      this.isLoading = false;
    })).subscribe(() => {
      this.isTaskCompleted = true;
    }, (error) => {
      /** @todo handle error */
      if (error.status == 422 && error.message) {
        this.errorMsg = error.message;
      } else if (error.status == 403) {
        this.errorMsg = "This task has been completed, doesn't exist, or you don't have access to it."
      }
    });
  }
}
